/*
 * @Author: zhanghan
 * @Date: 2021-01-23 21:55:45
 * @LastEditors: zhanghan
 * @LastEditTime: 2022-06-27 11:29:57
 * @Descripttion:
 */
import Vue from "vue";
import Router from "vue-router";

import Blog from "@/view/blog/index";
import Time from "@/view/time/index";
import Code from "@/view/code/index";
import Article from "@/view/article/index";

import BAM from "@/view/BAM/layout";
import BAllBlog from "@/view/BAM/view/allBlog";
import BWriteBlog from "@/view/BAM/view/writeBlog/index";
import BDraft from "@/view/BAM/view/draft";
import BSelf from "@/view/BAM/view/self";

import Login from "@/view/login/index";

Vue.use(Router);

export default new Router({
  routes: [
    { path: "/", redirect: "/blog" },
    { path: "/blog", name: "blog", component: Blog, meta: { keepAlive: true } },
    { path: "/time", name: "time", component: Time, meta: { keepAlive: true } },
    { path: "/code", name: "code", component: Code, meta: { keepAlive: true } },
    { path: "/article", name: "article", component: Article },
    {
      path: "/BAM",
      component: BAM,
      redirect: "/BAM/BAllBlog",
      meta: { requireAuth: true },
      children: [
        {
          path: "BAllBlog",
          name: "BAllBlog",
          component: BAllBlog,
          meta: { requireAuth: true }
        },
        {
          path: "BWriteBlog",
          name: "BWriteBlog",
          component: BWriteBlog,
          meta: { requireAuth: true, keepAlive: false }
        },
        {
          path: "BDraft",
          name: "BDraft",
          component: BDraft,
          meta: { requireAuth: true }
        },
        { path: "BSelf", component: BSelf, meta: { requireAuth: true } }
      ]
    },
    { path: "/login", name: "login", component: Login }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js